import { Fragment, useEffect, useState } from "react";
import { Trash2 } from "react-feather";
import { Link, useParams } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";
import { scrollUpPage } from "src/_utils/elements";
import { CSS, parseHTML } from "src/_utils/styles";
import { getQueryParams } from "src/_utils/urls";
import Page from "src/base/Page";
import { EBSSSPagination } from "src/base/atoms/EBSSSPagination";
import { useEBSSS } from "src/base/context/EBSSSContext/useEBSSS";
import { useEBSSSLayout } from "src/base/context/EBSSSLayoutContext/useEBSSSLayout";
import { remotePath } from "src/base/settings/Paths";
import { H6, Image, LI, P, UL } from "../../../AbstractElements";
import { Session } from "src/base/store/authSlice";
import { useSelector } from "react-redux";
import { ReduxDataKey } from "src/base/store/store";
import { toast } from "react-toastify";
import EBSSSModal from "src/base/atoms/EBSSSModal";

const CollectionPage = () => {
  const sessionNow: Session = useSelector((state) => state[ReduxDataKey.AUTH]);
  const { trans } = useEBSSSLayout();
  const getCollection = useParams();
  const { bookmarks, bookmarksCollection, loaded, saveBookmarksCollection, addBookmarks, setBookmarks, getBookmarksCollection, removeBookmarks } = useEBSSS();
  const [page, setPage] = useState(null);
  const [ordering, setOrdering] = useState(null);
  const [sortBy, setSortBy] = useState("");
  const [filterSize, setFilterSize] = useState(undefined);
  const [stepSize, setStepSize] = useState(0);
  const [values, setValues] = useState([1, 100]);
  const [modal, setModal] = useState(false);
  const [collectionTitle, setCollectionTitle] = useState("");
  const [filterPrice, setFilterPrice] = useState({
    min: 0,
    max: undefined,
  });

  const toggleModal = () => {
    setModal(!modal);
  };

  const removeBk = async (token) => {
    try {
      setBookmarks((s) => {
        return { ...s, data: s.data?.filter((b) => b.token !== token) };
      });
      await removeBookmarks(token);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!!bookmarks && Array.isArray(bookmarks?.data) && bookmarks?.data?.length) {
      let filtersPriceMinMax = {
        ...filterPrice,
        max: Math.ceil(Number(bookmarks?.data?.sort((a, b) => Number(b.price) - Number(a.price))[0]?.price)),
      };
      setFilterPrice({
        ...filtersPriceMinMax,
      });
      setStepSize(
        //@ts-ignore
        String(bookmarks?.data?.sort((a, b) => Number(b.price) - Number(a.price))[0]?.price ?? 0) / 20
      );
      setValues([filtersPriceMinMax.min, filtersPriceMinMax.max]);
    }
  }, [bookmarks?.data]);

  useEffect(() => {
    let actualParams = getQueryParams(window.location.href);
    if (actualParams?.page) {
      setPage((p) => {
        if (p !== null) {
          return p;
        } else {
          return Number(actualParams?.page);
        }
      });
    }
  }, [window.location.search]);

  useEffect(() => {
    scrollUpPage();
    if (bookmarks?.data) {
      if (page && page > 0) {
        getBookmarksCollection({ page }, Number(getCollection?.id));
      }
    }
  }, [page]);

  useEffect(() => {
    scrollUpPage();
    let actualParams = getQueryParams(window.location.href);
    getBookmarksCollection({ page: actualParams?.page }, Number(getCollection?.id));
  }, []);

  console.log("sessionNow?.user?.bookmark_collections: ", sessionNow?.user?.bookmark_collections);

  return (
    <Page
      breads={[
        {
          name: `${trans("website.favorites")} ${bookmarksCollection?.title ?? ""}`,
          active: true,
          url: "/favorites?page=1",
        },
      ]}
    >
      <Fragment>
        <div className="email-wrap bookmark-wrap">
          <Row>
            <Col xl="12" md="12" className="box-col-12">
              <Card className="email-body radius-left">
                <CardBody className="pb-0">
                  <h3 className="lead mb-3">Coleções </h3>
                  <div className="d-flex flex-row flex-wrap gap-3">
                    <Card className="w-auto bg-light shadow-sm">
                      <CardBody style={CSS({ padding: 15 })}>
                        <Link to={`${process.env.PUBLIC_URL}/favorites?page=1`}>
                          <i className="la la-list me-2"></i>
                          {trans("website.favorites")}
                        </Link>
                      </CardBody>
                    </Card>
                    {sessionNow.user.bookmark_collections?.map((v) => {
                      return (
                        <Card className="w-auto bg-light shadow-sm">
                          <CardBody style={CSS({ padding: 15 })}>
                            <Link to={`${process.env.PUBLIC_URL}/favorites/collection/${v?.id}`}>{v.title}</Link>
                          </CardBody>
                        </Card>
                      );
                    })}
                    <Card className="w-auto bg-light shadow-sm">
                      <EBSSSModal
                        customConfirmAction={async () => {
                          await saveBookmarksCollection(collectionTitle);
                        }}
                        toggle={toggleModal}
                        modal={modal}
                        modalTitle={trans("website.new-collection")}
                        triggerEl={
                          <CardBody style={CSS({ padding: 15 })}>
                            <a
                              href="/"
                              className="d-flex align-items-center justify-content-center text-center m-auto"
                              onClick={(e) => {
                                e.preventDefault();
                                toggleModal();
                              }}
                            >
                              <i className="la la-plus-circle fs-5 m-auto text-center align-self-center"></i>
                            </a>
                          </CardBody>
                        }
                      >
                        <div>
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder={trans("website.collection-title")}
                              onChange={(e) => setCollectionTitle(e.target.value)}
                            />
                          </div>
                        </div>
                      </EBSSSModal>
                    </Card>
                  </div>
                </CardBody>
              </Card>
              <div className="email-right-aside bookmark-tabcontent">
                <Card className="email-body radius-left">
                  <CardBody className="pb-0">
                    <div className={`details-bookmark text-center ''`}>
                      <Fragment>
                        <Row id="bookmarkData">
                          {bookmarks?.data?.length > 0 ? (
                            bookmarks?.data?.map((data) => {
                              return (
                                <Col xl="3" lg="6" sm="6" md="4" key={data.id} className="xl-25 box-col-3">
                                  <Card className="bookmark-card o-hidden" style={CSS({ height: "97.5%" })}>
                                    <div className="details-website">
                                      <Link to={`${process.env.PUBLIC_URL}/crm/products/${data?.product?.slug}`}>
                                        <Image
                                          attrImage={{
                                            className: "img-fluid",
                                            src: `${
                                              data?.product?.photo
                                                ? remotePath.assetsUrl(data?.product?.photo)
                                                : "https://www.coop.se/Assets/Images/missing-image-product.png"
                                            }`,
                                            alt: "",
                                          }}
                                        />
                                      </Link>
                                      <div className="desciption-data">
                                        <div className="title-bookmark">
                                          <Link to={`${process.env.PUBLIC_URL}/crm/products/${data?.product?.slug}`}>
                                            <H6
                                              attrH6={{
                                                className: "title_0",
                                              }}
                                            >
                                              {data?.product?.name}{" "}
                                            </H6>
                                          </Link>
                                          <div className="d-flex flex-row justify-content-center align-items-center text-center mt-4">
                                            <UL
                                              attrUL={{
                                                className: "d-flex flex-row text-center justify-content-center align-items-center simple-list flex-row",
                                              }}
                                            >
                                              <LI>
                                                <span
                                                  style={CSS({
                                                    cursor: "pointer",
                                                  })}
                                                  onClick={async () => await removeBk(data?.token)}
                                                >
                                                  <Trash2 className="text-danger me-3 mt-1" size={20} />
                                                </span>
                                              </LI>
                                              <LI>
                                                <select
                                                  name=""
                                                  id=""
                                                  className="form-control form-select-sm"
                                                  onChange={async (e) => {
                                                    if (!e.target.value) return;
                                                    await addBookmarks(data?.product?.token, Number(e.target.value), data?.id, true).then((r) => {
                                                      console.log("Result after bookmark: ", r);
                                                      let isntInFavs = !data?.product?.settings?.favorited;
                                                      toast(
                                                        data?.product?.name + " " + trans("website.removed-from-collection"),

                                                        { type: isntInFavs ? "success" : "error" }
                                                      );
                                                      setBookmarks({ ...bookmarks, data: bookmarks?.data?.filter((b) => b?.id !== data?.id) });
                                                      return;
                                                    });
                                                  }}
                                                >
                                                  <option value="">{trans("website.collection-choose")}</option>
                                                  <option value={"0"}>{trans("common.remove")}</option>
                                                  {sessionNow.user.bookmark_collections
                                                    ?.filter((bc) => Number(bc.id) !== Number(getCollection?.id))
                                                    .map((v) => {
                                                      return <option value={v.id}>{v.title}</option>;
                                                    })}
                                                </select>
                                              </LI>
                                            </UL>
                                          </div>
                                          <div className="content-general">
                                            <P
                                              attrPara={{
                                                className: "desc_3",
                                              }}
                                            >
                                              {data.desc}
                                            </P>
                                            <span className="collection_3">{data?.colection}</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </Card>
                                </Col>
                              );
                            })
                          ) : (
                            <Col xl="12">
                              <div className="no-favourite">
                                {" "}
                                <span>{trans("website.no_favorites_found")}</span>
                              </div>{" "}
                            </Col>
                          )}
                        </Row>
                      </Fragment>
                    </div>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>
        </div>
        <EBSSSPagination page={page} data={{ ...bookmarks, data: bookmarks?.data?.map((b) => b.product) }} />
      </Fragment>
    </Page>
  );
};
export default CollectionPage;
